/* ================================================================
   DTF Gears · Best UV Printers — assets/dtfg-best-uv-printers.js  (v3)
   ================================================================ */
(function () {
  'use strict';
  const RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const FINE = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const pad = (n) => (n < 10 ? '0' : '') + n;
  const debounce = (fn, ms) => { let t; return () => { clearTimeout(t); t = setTimeout(fn, ms); }; };
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const onScroll = (fn) => {
    let tick = false;
    const run = () => { if (tick) return; tick = true; requestAnimationFrame(() => { tick = false; fn(); }); };
    window.addEventListener('scroll', run, { passive: true });
    window.addEventListener('resize', run);
    fn();
  };
  const topOffset = (root) => {
    const nav = $('.uvx-subnav', root);
    return (parseFloat(root.getAttribute('data-top')) || 0) + (nav ? nav.offsetHeight : 0);
  };

  /* ---------- Analytics (GA4 via gtag, else GTM dataLayer) ---------- */
  function track(event, params) {
    try {
      params = params || {};
      if (typeof window.gtag === 'function') window.gtag('event', event, params);
      else (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: event }, params));
    } catch (_) {}
  }

  /* ---------- Reveal on scroll ---------- */
  function reveal(root) {
    const els = $$('[data-uvx-reveal]', root);
    if (RM || !('IntersectionObserver' in window)) { els.forEach((e) => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.1 });
    els.forEach((e) => io.observe(e));
  }

  /* ---------- Counters ---------- */
  function counters(root) {
    const els = $$('[data-count]', root);
    const run = (el) => {
      const to = parseFloat(el.dataset.count);
      if (isNaN(to) || RM) return;
      const t0 = performance.now(), dur = 1800;
      const step = (t) => {
        const p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 4);
        el.textContent = Math.round(to * e);
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    if (!('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.6 });
    els.forEach((e) => io.observe(e));
  }

  /* ---------- Hero: UV lamp + ink particles ---------- */
  function hero(root) {
    const h = $('.uvx-hero', root);
    if (!h) return;
    if (RM) { h.style.setProperty('--mx', '50%'); h.style.setProperty('--my', '40%'); return; }
    let tx = 0.5, ty = 0.4, cx = 0.5, cy = 0.4, auto = !FINE, visible = true, raf = 0;
    const t0 = performance.now();
    if (FINE) {
      h.addEventListener('pointermove', (e) => {
        const r = h.getBoundingClientRect();
        tx = (e.clientX - r.left) / r.width; ty = (e.clientY - r.top) / r.height; auto = false;
      }, { passive: true });
      h.addEventListener('pointerleave', () => { auto = true; });
    }
    const cv = $('.uvx-ink', h), ctx = cv && cv.getContext('2d');
    const cols = ['#22d3ee', '#f472b6', '#facc15', '#8b5cf6', '#6366f1'];
    let W = 0, H = 0, parts = [];
    const size = () => {
      if (!ctx) return;
      const dpr = Math.min(2, window.devicePixelRatio || 1);
      W = h.clientWidth; H = h.clientHeight;
      cv.width = W * dpr; cv.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      const n = Math.round(clamp((W * H) / 16000, 24, 80));
      parts = Array.from({ length: n }, () => ({
        x: Math.random() * W, y: Math.random() * H, r: Math.random() * 1.8 + 0.4,
        vx: (Math.random() - 0.5) * 0.25, vy: -(Math.random() * 0.35 + 0.06),
        c: cols[(Math.random() * cols.length) | 0], a: Math.random() * 0.55 + 0.2
      }));
    };
    const frame = (t) => {
      if (!visible) { raf = 0; return; }
      if (auto) { const k = (t - t0) / 1000; tx = 0.5 + Math.sin(k * 0.5) * 0.32; ty = 0.45 + Math.sin(k * 0.8) * 0.22; }
      cx += (tx - cx) * 0.08; cy += (ty - cy) * 0.08;
      h.style.setProperty('--mx', (cx * 100).toFixed(2) + '%');
      h.style.setProperty('--my', (cy * 100).toFixed(2) + '%');
      h.style.setProperty('--hx', (cx - 0.5).toFixed(3));
      h.style.setProperty('--hy', (cy - 0.5).toFixed(3));
      if (ctx) {
        ctx.clearRect(0, 0, W, H);
        const mx = cx * W, my = cy * H;
        for (const p of parts) {
          p.x += p.vx; p.y += p.vy;
          const dx = p.x - mx, dy = p.y - my, d = Math.hypot(dx, dy) || 1;
          if (d < 160) { const f = ((160 - d) / 160) * 0.9; p.x += (dx / d) * f; p.y += (dy / d) * f; }
          if (p.y < -10) { p.y = H + 10; p.x = Math.random() * W; }
          if (p.x < -10) p.x = W + 10; else if (p.x > W + 10) p.x = -10;
          const near = d < 220;
          ctx.globalAlpha = p.a * (near ? 1 : 0.55);
          ctx.fillStyle = p.c;
          ctx.beginPath(); ctx.arc(p.x, p.y, p.r * (near ? 1.8 : 1), 0, 6.283); ctx.fill();
        }
      }
      raf = requestAnimationFrame(frame);
    };
    size();
    window.addEventListener('resize', debounce(size, 200));
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => { visible = e.isIntersecting; if (visible && !raf) raf = requestAnimationFrame(frame); }).observe(h);
    } else raf = requestAnimationFrame(frame);
  }

  /* ---------- Smooth anchors ---------- */
  function anchors(root) {
    root.addEventListener('click', (e) => {
      const a = e.target.closest('a[href^="#uvx-"]');
      if (!a) return;
      const t = root.querySelector(a.getAttribute('href'));
      if (!t) return;
      e.preventDefault();
      const y = t.getBoundingClientRect().top + window.scrollY - topOffset(root) + 1;
      window.scrollTo({ top: y, behavior: RM ? 'auto' : 'smooth' });
    });
  }

  /* ---------- Sub nav scrollspy ---------- */
  function subnav(root) {
    const nav = $('.uvx-subnav', root);
    if (!nav) return;
    const inner = $('.uvx-subnav__inner', nav), pill = $('.uvx-subnav__pill', nav);
    const links = $$('a[href^="#"]', nav);
    const pairs = links.map((a) => [root.querySelector(a.getAttribute('href')), a]).filter((p) => p[0]);
    let active = null;
    const place = (a) => {
      links.forEach((l) => l.classList.toggle('is-active', l === a));
      if (!pill) return;
      if (!a) { pill.style.opacity = 0; return; }
      pill.style.width = a.offsetWidth + 'px';
      pill.style.transform = 'translateX(' + a.offsetLeft + 'px)';
      pill.style.opacity = 1;
      inner.scrollTo({ left: a.offsetLeft - inner.clientWidth / 2 + a.offsetWidth / 2, behavior: RM ? 'auto' : 'smooth' });
    };
    onScroll(() => {
      const off = topOffset(root) + 60;
      let cur = null;
      pairs.forEach(([sec, a]) => { if (sec.getBoundingClientRect().top - off <= 0) cur = a; });
      if (cur !== active) { active = cur; place(cur); }
    });
    window.addEventListener('resize', debounce(() => place(active), 150));
  }

  /* ---------- Butter 3D slider ---------- */
  function slider(el) {
    const stage = $('.uvx-slider__stage', el);
    const cards = $$('.uvx-card', stage);
    const n = cards.length;
    if (!n) return;
    const cur = $('[data-uvx-cur]', el), prev = $('[data-uvx-prev]', el), next = $('[data-uvx-next]', el), dotsBox = $('[data-uvx-dots]', el);
    let pos = 0, target = 0, raf = 0, active = -1;
    let down = false, captured = false, startX = 0, startY = 0, startT = 0, lastX = 0, lastTime = 0, vel = 0, moved = 0, pid = null, suppress = false;

    const dots = [];
    if (dotsBox) for (let i = 0; i < n; i++) {
      const d = document.createElement('button');
      d.type = 'button'; d.className = 'uvx-dot'; d.setAttribute('aria-label', 'Go to printer ' + (i + 1));
      d.addEventListener('click', () => go(i));
      dotsBox.appendChild(d); dots.push(d);
    }

    const spacing = () => {
      const w = cards[0].offsetWidth, vw = window.innerWidth;
      return vw < 640 ? w * 0.9 : vw < 990 ? w * 0.8 : w * 0.78;
    };

    function measure() {
      stage.style.setProperty('--ch', 'auto');
      let h = 0;
      cards.forEach((c) => { h = Math.max(h, $('.uvx-face--front', c).offsetHeight); });
      stage.style.setProperty('--ch', h + 'px');
      stage.style.setProperty('--sh', h + 36 + 'px');
      render();
    }

    const unflip = (c) => {
      c.classList.remove('is-flipped');
      $$('[data-uvx-flip]', c).forEach((b) => b.setAttribute('aria-pressed', 'false'));
    };

    function render() {
      const sp = spacing();
      for (let i = 0; i < n; i++) {
        const c = cards[i], o = i - pos, a = Math.abs(o);
        const rot = clamp(-o * 20, -50, 50), z = -Math.min(a, 4) * 150, s = 1 - Math.min(a, 3) * 0.05;
        const op = a > 2.8 ? 0 : a < 1 ? 1 : 1 - (a - 1) * 0.42;
        c.style.transform = 'translate3d(' + (o * sp).toFixed(2) + 'px,0,' + z.toFixed(1) + 'px) rotateY(' + rot.toFixed(2) + 'deg) scale(' + s.toFixed(3) + ')';
        c.style.opacity = op.toFixed(3);
        c.style.zIndex = String(200 - Math.round(a * 10));
        c.style.visibility = a > 2.9 ? 'hidden' : 'visible';
      }
      const idx = clamp(Math.round(pos), 0, n - 1);
      if (idx !== active) {
        active = idx;
        cards.forEach((c, i) => {
          const on = i === idx;
          c.classList.toggle('is-active', on);
          if (!on) { unflip(c); c.classList.remove('is-tilting'); }
        });
        dots.forEach((d, i) => d.classList.toggle('is-on', i === idx));
        if (cur) cur.textContent = pad(idx + 1);
        if (prev) prev.disabled = idx === 0;
        if (next) next.disabled = idx === n - 1;
      }
    }

    function loop() {
      const k = down ? 0.4 : RM ? 1 : 0.11;
      pos += (target - pos) * k;
      if (!down && Math.abs(target - pos) < 0.0008) { pos = target; render(); raf = 0; return; }
      render();
      raf = requestAnimationFrame(loop);
    }
    const kick = () => { if (!raf) raf = requestAnimationFrame(loop); };
    function go(i) { target = clamp(Math.round(i), 0, n - 1); kick(); }
    el.__uvxGo = go;

    stage.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (e.target.closest('.uvx-face--back, .uvx-card__pay, [data-uvx-flip]')) return;
      down = true; captured = false; moved = 0; suppress = false;
      startX = lastX = e.clientX; startY = e.clientY; startT = target; lastTime = performance.now(); vel = 0; pid = e.pointerId;
    });
    stage.addEventListener('pointermove', (e) => {
      if (!down || e.pointerId !== pid) return;
      const dx = e.clientX - startX;
      moved = Math.max(moved, Math.abs(dx));
      if (!captured) {
        if (Math.abs(dx) < 6) return;
        if (Math.abs(e.clientY - startY) > Math.abs(dx)) { down = false; return; }
        try { stage.setPointerCapture(pid); } catch (_) {}
        captured = true; el.classList.add('is-dragging');
        cards.forEach((c) => c.classList.remove('is-tilting'));
      }
      const now = performance.now(), dt = Math.max(1, now - lastTime);
      vel = vel * 0.6 + ((e.clientX - lastX) / dt) * 0.4;
      lastX = e.clientX; lastTime = now;
      let t = startT - dx / spacing();
      if (t < 0) t *= 0.35;
      if (t > n - 1) t = n - 1 + (t - (n - 1)) * 0.35;
      target = t; kick();
    });
    const end = () => {
      if (!down) return;
      down = false;
      if (captured) {
        suppress = moved > 6;
        el.classList.remove('is-dragging');
        try { stage.releasePointerCapture(pid); } catch (_) {}
        go(target - (vel * 230) / spacing());
      }
      captured = false;
    };
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);
    stage.addEventListener('lostpointercapture', end);

    /* Capture-phase click: handles flip FIRST so nothing underneath can steal it */
    stage.addEventListener('click', (e) => {
      if (suppress) { e.preventDefault(); e.stopPropagation(); suppress = false; return; }
      const c = e.target.closest('.uvx-card');
      if (!c) return;
      const i = cards.indexOf(c);
      if (i !== active) { e.preventDefault(); e.stopPropagation(); go(i); return; }
      const f = e.target.closest('[data-uvx-flip]');
      if (f) {
        e.preventDefault();
        e.stopPropagation();
        const on = !c.classList.contains('is-flipped');
        c.classList.toggle('is-flipped', on);
        c.classList.remove('is-tilting');
        $$('[data-uvx-flip]', c).forEach((b) => b.setAttribute('aria-pressed', String(on)));
        const target2 = on ? $('.uvx-face--back [data-uvx-flip]', c) : $('.uvx-face--front [data-uvx-flip]', c);
        if (target2) setTimeout(() => target2.focus({ preventScroll: true }), 500);
        if (on) track('uvx_card_flip', { product: c.dataset.title || '' });
      }
    }, true);

    let wt;
    stage.addEventListener('wheel', (e) => {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault();
      target = clamp(target + (e.deltaX / spacing()) * 1.1, -0.3, n - 0.7);
      kick();
      clearTimeout(wt); wt = setTimeout(() => go(target), 120);
    }, { passive: false });

    el.addEventListener('keydown', (e) => {
      if (e.target.closest('input, select, textarea')) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); go(active + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(active - 1); }
    });
    stage.addEventListener('focusin', (e) => {
      const i = cards.indexOf(e.target.closest('.uvx-card'));
      if (i > -1 && i !== active) go(i);
    });
    if (prev) prev.addEventListener('click', () => go(active - 1));
    if (next) next.addEventListener('click', () => go(active + 1));

    if (FINE && !RM) {
      cards.forEach((c) => {
        const t = $('.uvx-card__tilt', c);
        c.addEventListener('pointermove', (e) => {
          if (!c.classList.contains('is-active') || captured || c.classList.contains('is-flipped')) return;
          const r = c.getBoundingClientRect();
          const px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5;
          c.classList.add('is-tilting');
          t.style.setProperty('--rx', (-py * 10).toFixed(2) + 'deg');
          t.style.setProperty('--ry', (px * 12).toFixed(2) + 'deg');
          t.style.setProperty('--px', px.toFixed(3));
          t.style.setProperty('--py', py.toFixed(3));
          t.style.setProperty('--gx', ((px + 0.5) * 100).toFixed(1) + '%');
          t.style.setProperty('--gy', ((py + 0.5) * 100).toFixed(1) + '%');
        });
        c.addEventListener('pointerleave', () => {
          c.classList.remove('is-tilting');
          ['--rx', '--ry', '--px', '--py'].forEach((p) => t.style.removeProperty(p));
        });
      });
    }

    measure();
    window.addEventListener('resize', debounce(measure, 150));
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    window.addEventListener('load', measure);
    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(debounce(measure, 80));
      cards.forEach((c) => {
        const f = $('.uvx-card__foot', c), p = $('.uvx-card__pay', c);
        if (f) ro.observe(f);
        if (p) ro.observe(p);
      });
    }
  }

  /* ---------- Toast + cart + upsell ---------- */
  function toast(root, html, type, ms) {
    const t = $('.uvx-toast', root);
    if (!t) return;
    t.innerHTML = html;
    t.className = 'uvx-toast is-show' + (type ? ' ' + type : '');
    const hide = () => { clearTimeout(t._t); t._t = setTimeout(() => t.classList.remove('is-show'), ms || 4200); };
    hide();
    t.onmouseenter = () => clearTimeout(t._t);
    t.onmouseleave = hide;
  }
  function refreshCount(base) {
    fetch(base + 'cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((c) => {
        $$('[data-cart-count], .cart-count, .cart-count-bubble span[aria-hidden="true"]').forEach((el) => { el.textContent = c.item_count; });
      })
      .catch(() => {});
  }
  function cart(root, data) {
    const upsells = {};
    data.forEach((p) => { if (p.variant && p.upsell) upsells[String(p.variant)] = p.upsell; });
    const checkSvg = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

    root.addEventListener('click', async (e) => {
      const b = e.target.closest('[data-uvx-add]');
      if (!b) return;
      const id = b.getAttribute('data-uvx-add');
      if (!id || b.classList.contains('is-loading')) return;
      e.preventDefault();
      const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      b.classList.remove('is-done');
      b.classList.add('is-loading');
      b.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        });
        const resData = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(resData.description || resData.message || 'Could not add this item.');
        b.classList.remove('is-loading');
        b.classList.add('is-done');
        const item = resData.items && resData.items[0];
        const title = item ? item.product_title : 'Item';
        track('uvx_add_to_cart', { variant_id: id, product: title, value: item ? item.final_price / 100 : undefined, currency: root.dataset.currency });
        const up = upsells[String(id)];
        let upHtml = '';
        if (up) {
          upHtml = '<span class="uvx-toast__up">' + (up.image ? '<img src="' + esc(up.image) + '" alt="">' : '') +
            '<span>Complete your setup: <b>' + esc(up.title) + '</b> · ' + esc(up.price) + '</span>' +
            '<button type="button" class="uvx-btn uvx-btn--primary uvx-btn--xs" data-uvx-add="' + esc(up.variant) + '"><span class="uvx-btn__txt">+ Add</span><span class="uvx-btn__spin" aria-hidden="true"></span><span class="uvx-btn__ok" aria-hidden="true">' + checkSvg + '</span></button></span>';
        }
        toast(root,
          '<span class="uvx-toast__ok">✓</span><div class="uvx-toast__body"><span><strong>' + esc(title) + '</strong> added to your cart</span>' + upHtml + '</div><a href="' + base + 'cart">View cart</a>',
          '', up ? 9000 : 4200);
        refreshCount(base);
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(() => b.classList.remove('is-done'), 2200);
      } catch (err) {
        b.classList.remove('is-loading');
        toast(root, '<span>' + esc(err.message) + '</span>', 'is-err');
      } finally {
        b.removeAttribute('aria-busy');
      }
    });
  }

  /* ---------- Profit calculator ---------- */
  function roi(root) {
    const box = $('[data-uvx-roi]', root);
    if (!box) return;
    const cur = root.dataset.currency || 'USD';
    let f0, f2;
    try {
      f0 = new Intl.NumberFormat(undefined, { style: 'currency', currency: cur, maximumFractionDigits: 0 });
      f2 = new Intl.NumberFormat(undefined, { style: 'currency', currency: cur, minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } catch (_) {
      f0 = { format: (v) => '$' + Math.round(v).toLocaleString() };
      f2 = { format: (v) => '$' + v.toFixed(2) };
    }
    const sel = $('[data-roi="printer"]', box);
    const ranges = $$('input[type="range"]', box);
    const get = (k) => parseFloat($('[data-roi="' + k + '"]', box).value) || 0;
    const out = (k, v) => { const el = $('[data-out="' + k + '"]', box); if (el) el.textContent = v; };
    const res = (k) => $('[data-res="' + k + '"]', box);
    const fill = $('.uvx-roi__fill', box), link = $('[data-roi-link]', box);
    let shown = 0, animRaf = 0, tracked = false;

    const tween = (to) => {
      const el = res('month');
      cancelAnimationFrame(animRaf);
      if (RM) { el.textContent = f0.format(to); shown = to; return; }
      const from = shown, t0 = performance.now(), dur = 600;
      const step = (t) => {
        const p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
        shown = from + (to - from) * e;
        el.textContent = f0.format(shown);
        if (p < 1) animRaf = requestAnimationFrame(step);
      };
      animRaf = requestAnimationFrame(step);
    };

    function calc() {
      ranges.forEach((i) => { i.style.setProperty('--p', ((i.value - i.min) / (i.max - i.min)) * 100 + '%'); });
      const price = parseFloat(sel.value) || 0;
      const blank = get('blank'), sell = get('sell'), ink = get('ink'), units = get('units');
      out('blank', f2.format(blank));
      out('sell', f2.format(sell));
      out('ink', f2.format(ink));
      out('units', units + ' / week');
      const per = sell - blank - ink;
      const week = per * units;
      const month = (week * 52) / 12;
      tween(Math.max(0, month));
      res('per').textContent = f2.format(per);
      res('week').textContent = f0.format(Math.max(0, week));
      box.classList.toggle('is-neg', per <= 0);
      if (week > 0 && price > 0) {
        const weeks = Math.ceil(price / week);
        const months = weeks / 4.33;
        res('payback').textContent = weeks <= 1 ? 'under 1 week' : weeks + ' weeks' + (weeks >= 8 ? ' (~' + months.toFixed(1) + ' mo)' : '');
        fill.style.width = clamp((weeks / 52) * 100, 3, 100) + '%';
      } else {
        res('payback').textContent = '—';
        fill.style.width = '0%';
      }
      const opt = sel.selectedOptions && sel.selectedOptions[0];
      if (opt && link) link.href = opt.dataset.url || '#';
    }
    const onUse = () => { calc(); if (!tracked) { tracked = true; track('uvx_roi_use', {}); } };
    ranges.forEach((i) => i.addEventListener('input', onUse));
    sel.addEventListener('change', onUse);
    calc();
  }

  /* ---------- Quiz ---------- */
  function quiz(root, data) {
    const q = $('[data-uvx-quiz]', root);
    if (!q) return;
    const steps = $$('.uvx-quiz__step', q), result = $('.uvx-quiz__result', q), bar = $('.uvx-quiz__bar i', q);
    const qn = $('[data-uvx-qn]', q), back = $('[data-uvx-qback]', q), total = steps.length;
    let idx = 0;
    const picks = [];
    const set = (s, v) => { const el = $(s, result); if (el) el.textContent = v; };

    function show(i) {
      idx = i;
      steps.forEach((s, k) => { s.hidden = k !== i; s.classList.toggle('is-current', k === i); });
      result.hidden = true;
      if (bar) bar.style.width = ((i + 1) / (total + 1)) * 100 + '%';
      if (qn) qn.textContent = i + 1;
      if (back) back.hidden = i === 0;
    }

    function finish() {
      if (!data.length) return;
      const scored = data.map((p, i) => {
        const tags = (p.tags || '').toLowerCase().split(',').map((t) => t.trim()).filter(Boolean);
        return { p, i, s: picks.filter((t) => tags.includes(t)).length };
      }).sort((a, b) => b.s - a.s || a.i - b.i);
      const best = scored[0], p = best.p;
      steps.forEach((s) => { s.hidden = true; s.classList.remove('is-current'); });
      if (back) back.hidden = true;
      if (bar) bar.style.width = '100%';
      if (qn) qn.textContent = total;
      const img = $('[data-r-img]', result);
      if (p.image) { img.src = p.image; img.alt = p.title; img.hidden = false; } else img.hidden = true;
      set('[data-r-award]', p.award || 'Top match');
      set('[data-r-title]', p.title);
      set('[data-r-reason]', p.reason || '');
      set('[data-r-price]', p.price || '');
      set('[data-r-score]', 'Matches ' + best.s + ' of your ' + picks.length + ' answers');
      const add = $('[data-r-add]', result);
      if (p.variant && p.available) { add.hidden = false; add.setAttribute('data-uvx-add', p.variant); } else add.hidden = true;
      const link = $('[data-r-link]', result);
      link.href = p.url || '#';
      const see = $('[data-r-see]', result);
      if (see) see.onclick = () => { const sl = $('[data-uvx-slider]', root); if (sl && sl.__uvxGo) sl.__uvxGo(best.i); };
      result.hidden = false;
      result.classList.remove('is-pop');
      void result.offsetWidth;
      result.classList.add('is-pop');
      track('uvx_quiz_complete', { match: p.title, answers: picks.join(',') });
    }

    q.addEventListener('click', (e) => {
      const o = e.target.closest('.uvx-opt');
      if (o) {
        const s = o.closest('.uvx-quiz__step');
        $$('.uvx-opt', s).forEach((x) => { x.classList.toggle('is-picked', x === o); x.setAttribute('aria-pressed', String(x === o)); });
        picks[idx] = o.dataset.tag;
        setTimeout(() => { if (idx < total - 1) show(idx + 1); else finish(); }, RM ? 0 : 380);
        return;
      }
      if (e.target.closest('[data-uvx-qback]')) { if (idx > 0) show(idx - 1); return; }
      if (e.target.closest('[data-uvx-qreset]')) {
        picks.length = 0;
        $$('.uvx-opt', q).forEach((x) => { x.classList.remove('is-picked'); x.setAttribute('aria-pressed', 'false'); });
        show(0);
      }
    });
    show(0);
  }

  /* ---------- Compare table ---------- */
  function compare(root) {
    const t = $('.uvx-table', root);
    if (!t) return;
    if (FINE) {
      t.addEventListener('pointerover', (e) => {
        const c = e.target.closest('[data-col]');
        const col = c ? c.dataset.col : null;
        $$('[data-col]', t).forEach((x) => x.classList.toggle('is-col', x.dataset.col === col));
      });
      t.addEventListener('pointerleave', () => $$('.is-col', t).forEach((x) => x.classList.remove('is-col')));
    }
    const tg = $('[data-uvx-diff]', root);
    if (tg) tg.addEventListener('change', () => {
      $$('tbody tr', t).forEach((tr) => {
        if (tr.classList.contains('uvx-table__cta')) return;
        const vals = $$('td', tr).map((td) => td.textContent.trim());
        const same = vals.length > 1 && vals.every((v) => v === vals[0]);
        tr.classList.toggle('is-same', tg.checked && same);
      });
    });
  }

  /* ---------- Tabs ---------- */
  function tabs(root) {
    $$('[data-uvx-tabs]', root).forEach((list) => {
      const tabsEls = $$('[role="tab"]', list), pill = $('.uvx-tabs__pill', list);
      let current = tabsEls.find((t) => t.getAttribute('aria-selected') === 'true') || tabsEls[0];
      const sel = (t) => {
        current = t;
        tabsEls.forEach((x) => {
          const on = x === t;
          x.setAttribute('aria-selected', String(on));
          x.tabIndex = on ? 0 : -1;
          const p = root.querySelector('#' + x.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
        if (pill) { pill.style.width = t.offsetWidth + 'px'; pill.style.transform = 'translateX(' + t.offsetLeft + 'px)'; pill.style.opacity = 1; }
      };
      tabsEls.forEach((t, i) => {
        t.addEventListener('click', () => sel(t));
        t.addEventListener('keydown', (e) => {
          let j = null;
          if (e.key === 'ArrowRight') j = (i + 1) % tabsEls.length;
          if (e.key === 'ArrowLeft') j = (i - 1 + tabsEls.length) % tabsEls.length;
          if (j !== null) { e.preventDefault(); tabsEls[j].focus(); sel(tabsEls[j]); }
        });
      });
      sel(current);
      window.addEventListener('resize', debounce(() => sel(current), 150));
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => sel(current));
    });
  }

  /* ---------- FAQ smooth accordion ---------- */
  function faq(root) {
    $$('.uvx-faq details', root).forEach((d) => {
      const s = $('summary', d), body = $('.uvx-faq__a', d);
      s.addEventListener('click', (e) => {
        if (RM || !body.animate) return;
        e.preventDefault();
        if (d.open) {
          const h = body.offsetHeight;
          const a = body.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 380, easing: 'cubic-bezier(.22,1,.36,1)' });
          a.onfinish = () => { d.open = false; };
        } else {
          d.open = true;
          const h = body.offsetHeight;
          body.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 480, easing: 'cubic-bezier(.22,1,.36,1)' });
        }
      });
    });
  }

  /* ---------- Buttons: ripple + magnetic ---------- */
  function buttons(root) {
    root.addEventListener('pointerdown', (e) => {
      const b = e.target.closest('.uvx-btn');
      if (!b || RM) return;
      const r = b.getBoundingClientRect(), s = Math.max(r.width, r.height);
      const sp = document.createElement('span');
      sp.className = 'uvx-ripple';
      sp.style.cssText = 'width:' + s + 'px;height:' + s + 'px;left:' + (e.clientX - r.left - s / 2) + 'px;top:' + (e.clientY - r.top - s / 2) + 'px';
      b.appendChild(sp);
      setTimeout(() => sp.remove(), 800);
    });
    if (!FINE || RM) return;
    $$('[data-magnetic]', root).forEach((b) => {
      b.addEventListener('pointermove', (e) => {
        const r = b.getBoundingClientRect();
        b.style.setProperty('--mgx', ((e.clientX - r.left - r.width / 2) * 0.22).toFixed(1) + 'px');
        b.style.setProperty('--mgy', ((e.clientY - r.top - r.height / 2) * 0.3).toFixed(1) + 'px');
      });
      b.addEventListener('pointerleave', () => { b.style.setProperty('--mgx', '0px'); b.style.setProperty('--mgy', '0px'); });
    });
  }

  /* ---------- Spotlight hover ---------- */
  function spot(root) {
    if (!FINE) return;
    root.addEventListener('pointermove', (e) => {
      const el = e.target.closest('[data-spot]');
      if (!el) return;
      const r = el.getBoundingClientRect();
      el.style.setProperty('--sx', e.clientX - r.left + 'px');
      el.style.setProperty('--sy', e.clientY - r.top + 'px');
    }, { passive: true });
  }

  /* ---------- Accessories rail ---------- */
  function rails(root) {
    $$('[data-uvx-railwrap]', root).forEach((w) => {
      const r = $('[data-uvx-rail]', w);
      $$('[data-rail]', w).forEach((b) => b.addEventListener('click', () => {
        r.scrollBy({ left: (b.dataset.rail === 'next' ? 1 : -1) * r.clientWidth * 0.85, behavior: RM ? 'auto' : 'smooth' });
      }));
    });
  }

  /* ---------- Guide TOC ---------- */
  function guide(root) {
    const g = $('.uvx-guide', root);
    if (!g) return;
    const links = $$('.uvx-toc a', g);
    const heads = links.map((a) => g.querySelector(a.getAttribute('href')));
    const bar = $('.uvx-toc__bar i', g), art = $('.uvx-article', g);
    onScroll(() => {
      const mark = window.innerHeight * 0.35;
      const r = art.getBoundingClientRect();
      if (bar) bar.style.transform = 'scaleY(' + clamp((mark - r.top) / r.height, 0, 1).toFixed(3) + ')';
      let cur = 0;
      heads.forEach((h, i) => { if (h && h.getBoundingClientRect().top < mark) cur = i; });
      links.forEach((a, i) => a.classList.toggle('is-active', i === cur));
    });
  }

  /* ---------- Mobile sticky bar ---------- */
  function mbar(root) {
    const bar = $('.uvx-mbar', root), heroEl = $('.uvx-hero', root);
    if (!bar || !heroEl || !('IntersectionObserver' in window)) return;
    const hide = new Set(['#uvx-quiz', '#uvx-cta', '#uvx-roi'].map((s) => $(s, root)).filter(Boolean));
    let heroOut = false;
    const inView = new Set();
    const upd = () => bar.classList.toggle('is-show', heroOut && inView.size === 0);
    new IntersectionObserver(([e]) => { heroOut = !e.isIntersecting; upd(); }).observe(heroEl);
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) inView.add(en.target); else inView.delete(en.target); });
      upd();
    }, { threshold: 0.15 });
    hide.forEach((s) => io.observe(s));
  }

  /* ---------- Init ---------- */
  function init(root) {
    if (root.__uvx) return;
    root.__uvx = true;
    root.classList.add('uvx-js');
    let data = [];
    try { data = JSON.parse(($('[data-uvx-data]', root) || {}).textContent || '[]'); } catch (_) {}
    reveal(root); counters(root); hero(root); anchors(root); subnav(root);
    $$('[data-uvx-slider]', root).forEach(slider);
    cart(root, data); roi(root); quiz(root, data); compare(root); tabs(root); faq(root);
    buttons(root); spot(root); rails(root); guide(root); mbar(root);
  }
  const boot = () => $$('[data-uvx-root]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', (e) => { const r = e.target.querySelector('[data-uvx-root]'); if (r) init(r); });
})();